// extracted by mini-css-extract-plugin
module.exports = {"socialLinkItem":"social-links-module--socialLinkItem--1VfUU","socialLinkIcon":"social-links-module--socialLinkIcon--3lb1D","socialLink":"social-links-module--socialLink--2LMCn"};